// ** React Imports
import React, { useState } from 'react'

// ** Third Party Components
import classnames from 'classnames'
import { Eye, EyeOff } from 'react-feather'
import { FormGroup, InputGroup, InputGroupAddon, Input, InputGroupText, Label } from 'reactstrap'

const PasswordField = (props) => {
  // ** Props
  const { formRef, hideIcon, showIcon, className, iconSize } = props

  // ** State
  const [inputVisibility, setInputVisibility] = useState(false)

  // ** Renders Icon Based On Visibility
  const renderIcon = () => {
    const size = iconSize ? iconSize : 14
    if (inputVisibility === false) {
      return showIcon ? showIcon : <EyeOff size={size} />
    } else {
      return hideIcon ? hideIcon : <Eye size={size} />
    }
  }

  return (
    <FormGroup className={`${props.hidden && 'hidden'}`}>
      <Label for={props.id} className='form-label'>
        {props.title} <span>{props.required && '*'}</span>
      </Label>
      <InputGroup
        className={classnames({
          [className]: className
        })}
      >
        <Input
          id={props.id}
          type={inputVisibility === false ? 'password' : 'text'}
          innerRef={formRef.register({
            required: props.required
          })}
          name={
            props.index !== undefined && props !== null
              ? `${props.name}[${props.index}]`
              : props.name
          }
          placeholder={
            props.index !== undefined && props !== null
             ? 'Enter text here'
              : props.placeholders[props.name]
          }
          invalid={
            props.index !== undefined && props !== null
              ? (formRef.errors && formRef.errors[props.name] && formRef.errors[props.name][props.index])
              : (formRef.errors && formRef.errors[props.name])
          }
          onKeyPress={(e) => {
            if (e.key === "Enter" && !e.shiftKey) e.stopPropagation()
          }}
        />
        <InputGroupAddon addonType='append' onClick={() => setInputVisibility(!inputVisibility)}>
          <InputGroupText className='cursor-pointer'>{renderIcon()}</InputGroupText>
        </InputGroupAddon>
      </InputGroup>
    </FormGroup>
  )
}

export default PasswordField
